<template>

    <m-edit1/>

    <m-single-brand-300 v-bind='{...{},...{}}' :style='""' class="" ></m-single-brand-300>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mSingleBrand300 from '@moeinmdn/miw-alpha-components/src/package/Brand/Single/SingleBrand300';

export default {
    name: 'HomeView',
    components: {mEdit1, mSingleBrand300 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
